module.exports = "../fonts/Arsenal-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Arsenal-Regular.ttf
// module id = 582
// module chunks = 0